import { render, staticRenderFns } from "./StatSoucrePie.vue?vue&type=template&id=0e520385&scoped=true"
import script from "./StatSoucrePie.vue?vue&type=script&lang=js"
export * from "./StatSoucrePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e520385",
  null
  
)

export default component.exports